import classNames from 'volta/helpers/class-names';
import { hash } from '@ember/helper';
import BvModalSectionHeader from 'volta/components/bv-modal/section-header';

import type { BvModalSectionHeaderSignature } from 'volta/components/bv-modal/section-header';
import type { ComponentLike, ContentValue } from '@glint/template';
import type { TOC } from '@ember/component/template-only';

export interface BvModalSectionSignature {
  Args: {
    flush?: boolean;
    subdued?: boolean;
    title?: ContentValue;
  };
  Blocks: {
    default: [props?: { Header: ComponentLike<BvModalSectionHeaderSignature> }];
    header: [];
  };
  Element: HTMLDivElement;
}

const BvModalSectionComponent: TOC<BvModalSectionSignature> = <template>
  <div
    class={{classNames
      'bv-modal__section'
      (if @flush 'bv-modal__section--flush bv-modal__content--flush')
      (if @subdued 'bv-modal__section--subdued')
    }}
    ...attributes
  >
    {{#if @title}}
      <BvModalSectionHeader @title={{@title}}>
        {{yield to='header'}}
      </BvModalSectionHeader>
      {{yield}}
    {{else}}
      {{yield (hash Header=(component BvModalSectionHeader title=@title))}}
    {{/if}}
  </div>
</template>;

export default BvModalSectionComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'BvModal::Section': typeof BvModalSectionComponent;
    'bv-modal/section': typeof BvModalSectionComponent;
  }
}
